import { Component, EventEmitter, inject, input, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { StripeElementsOptions, PaymentIntent, StripeCardElementOptions, PaymentMethodCreateParams, CreatePaymentMethodCustomerBalanceData, CreatePaymentMethodData } from '@stripe/stripe-js';
import { injectStripe, NgxStripeModule, StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { environment } from '../../../../environments/environment.development';
import { EnviaService } from '../../service/envia.service';
import { StripeServiceAngular } from '../../service/stripe.service';
import { Store } from '@ngxs/store';

import { CartState } from '../../state/cart.state';
import { CartActions } from '../../state/cart.actions';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStripe } from '@fortawesome/free-brands-svg-icons';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'app-form-payment-stripe',
  imports: [NgxStripeModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './form-payment-stripe.component.html',
  styleUrl: './form-payment-stripe.component.scss',
  standalone: true
})
export class FormPaymentStripeComponent {
  // ! Revisar la programacion para  que este formulario sea reutilizable
  /*
    Su funcion debe de solamente capturar los datos de la tarjeta y capturar el PM 
    Una ves que se tenga el PM se tiene q mandar los datos por un output y en el componente princilpa
    iniciar el proceso de payment inten o guardar los datos de la tarjeta para los customer depende el caso 
    que se requiera
  */
  private readonly gaService = inject(GoogleAnalyticsService);
  stripe = injectStripe(environment.stripe.token);
  @Input() amount;
  @Input() user;
  @Input() rate;
  @Input() listNameProduct;
  @Input() listproduct;
  @Output() paymentMethod = new EventEmitter<string>();
  @Input() successPaymentMessage;
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;

  iconSpinner = faSpinner;

  iconStripe = faStripe

  loadingToken = false;
  message: any;
  listStates;


  erroStripe = false;
  // successPaymentMessage = false;

  stripeCardForm: FormGroup;

  elementsOptions: StripeElementsOptions = {
    locale: 'es',
    currency: 'mxn',
  };
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        // backgroundColor:'white',
        padding: '10px 5px 10px 5px',
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#31325F',
        },
      },
      invalid: {
        iconColor: '#ffc7ee',
        color: '#f01e21',
      },
    },
  };

  constructor(
    private fb: FormBuilder,
    private enviaServices: EnviaService,
    private stripeService: StripeServiceAngular,
    private store: Store,
  ) {
  }
  ngOnInit(): void {
    this.amount = +this.amount;
    this.stripeCardForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
    });

    this.enviaServices.getStates(this.user.country).subscribe((res) => {
      this.listStates = res.data;
    });

  }
  createToken(amount = this.amount) {
    this.loadingToken = true;
    this.erroStripe = false;
    const user = {
      name: `${this.user.first_name} ${this.user.last_name} `,
      address_line1: `${this.user.street}`,
      address_zip: `${this.user.postalCode}`,
      address_state: this.listStates.find((f: any) => f.code_3_digits === this.user.state).name,
      address_country: `${this.user.country}`,
      city: `${this.user.city}`,
    };

    this.stripe.createToken(this.card.element, user).subscribe((result) => {
      this.gaService.event('payment', {
        category: 'success_token',
        label: 'Token',
      });

      if (result.hasOwnProperty('token')) {
        this.createPaymentMethod(result);
      } else if (result.error) {
        // ! revisar esta parte para regresar esos mensajes de errores o buscar como mostrarlos
        this.message = result.error.message;
      }
    });
  }
  createPaymentMethod(data) {
    const methodPayment: CreatePaymentMethodData = {
      type: 'card',
      card: {
        token: data?.token?.id!,
      },
    };

    this.stripe.createPaymentMethod(methodPayment).subscribe((res) => {
      const _pm = res?.paymentMethod?.id!;
      this.paymentMethod.emit(_pm);
    });
  }
}
